import { css } from "styled-components"

export const SwiperStyle = css`
  .swiper {
    width: 100%;
    height: 100%;          /* 👈 was: auto !important */

    .swiper-wrapper {
      align-items: center;
      height: 100%;        /* 👈 was: auto !important */
    }
  }
`

export const SliderStyle = css`
  .swiper-slide {
    height: 100%;          /* 👈 was: auto !important */
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
`